import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import store from './store';

export default {
	...store,
	name: 'class-grade',
	props: {
		label: {
			type: String,
			default: 'Ano de ensino'
		},
		selected: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		},
		defaultValueText: {
			type: String,
			default: 'Selecione'
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		onlySelect: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		classGradeModel: ''
	}),
	computed: {
		...mapGetters([
			'getLoggedUser',
			'classGrade',
			'classGradeList'
		]),
	},
	methods: {
		...mapActions([
			'getClassGrade',
			'setSelectedClassGrade'
		]),
		changed() {

			this.setSelectedClassGrade(this.classGradeModel);
			EventBus.$emit('classGradeSelected', this.classGradeModel);

		}
	},
	mounted() {

		this.classGradeModel = this.classGrade;

		if (this.selected) {
			this.classGradeModel = this.selected;
		}

		return this.getClassGrade({
			userId: this.getLoggedUser.id
		});

	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-grade/index.js